import { createContext, ReactNode, useContext, useMemo } from 'react';

import useToggle from '@shared/v2/hooks/useToggle';

export type OfferModalControlsContextValue = {
  isUpgradeModalOpen: boolean;
  openUpgradeModal: () => void;
  closeUpgradeModal: () => void;
  isOtherOptionModalOpen: boolean;
  openOtherOptionModal: () => void;
  closeOtherOptionModal: () => void;
};

const OfferModalControlsContext = createContext<OfferModalControlsContextValue>(
  {
    isUpgradeModalOpen: false,
    openUpgradeModal: () => {},
    closeUpgradeModal: () => {},
    isOtherOptionModalOpen: false,
    openOtherOptionModal: () => {},
    closeOtherOptionModal: () => {},
  },
);
const OfferModalControlsProvider = ({ children }: { children: ReactNode }) => {
  const {
    value: isUpgradeModalOpen,
    setOn: openUpgradeModal,
    setOff: closeUpgradeModal,
  } = useToggle(false);

  const {
    value: isOtherOptionModalOpen,
    setOn: openOtherOptionModal,
    setOff: closeOtherOptionModal,
  } = useToggle(false);

  const value = useMemo(
    () => ({
      isUpgradeModalOpen,
      openUpgradeModal,
      closeUpgradeModal,
      isOtherOptionModalOpen,
      openOtherOptionModal,
      closeOtherOptionModal,
    }),
    [
      closeOtherOptionModal,
      closeUpgradeModal,
      isOtherOptionModalOpen,
      isUpgradeModalOpen,
      openOtherOptionModal,
      openUpgradeModal,
    ],
  );

  return (
    <OfferModalControlsContext.Provider value={value}>
      {children}
    </OfferModalControlsContext.Provider>
  );
};

const useOfferModalControls = () => useContext(OfferModalControlsContext);

export { useOfferModalControls, OfferModalControlsProvider };
